import { supabase } from '../lib/supabase';

const BUCKET = 'project-images';

export const projectImageService = {
  async getByProject(projectId) {
    const { data, error } = await supabase
      ?.from('project_images')
      ?.select('*, uploaded_by_profile:user_profiles!project_images_uploaded_by_fkey(id, full_name, first_name, last_name, email)')
      ?.eq('project_id', projectId)
      ?.order('created_at', { ascending: false });
    if (error) throw error;
    return data || [];
  },

  async addImage(projectId, { title, imageNote, imageUrl }, userId) {
    const { data, error } = await supabase
      ?.from('project_images')
      ?.insert({
        project_id: projectId,
        uploaded_by: userId,
        title,
        image_note: imageNote || null,
        image_url: imageUrl || null,
        is_upload: false,
      })
      ?.select('*, uploaded_by_profile:user_profiles!project_images_uploaded_by_fkey(id, full_name, first_name, last_name, email)')
      ?.single();
    if (error) throw error;
    return data;
  },

  async updateImage(imageId, { title, imageNote, imageUrl }) {
    const { data, error } = await supabase
      ?.from('project_images')
      ?.update({
        title,
        image_note: imageNote || null,
        image_url: imageUrl || null,
      })
      ?.eq('id', imageId)
      ?.select('*, uploaded_by_profile:user_profiles!project_images_uploaded_by_fkey(id, full_name, first_name, last_name, email)')
      ?.single();
    if (error) throw error;
    return data;
  },

  async uploadFile(projectId, file, userId, title, imageNote) {
    const timestamp = Date.now();
    const safeName = file?.name?.replace(/[^a-zA-Z0-9._-]/g, '_');
    const filePath = `${projectId}/${timestamp}-${safeName}`;

    const { error: uploadError } = await supabase
      ?.storage
      ?.from(BUCKET)
      ?.upload(filePath, file, { cacheControl: '3600', upsert: false });
    if (uploadError) throw uploadError;

    const { data, error } = await supabase
      ?.from('project_images')
      ?.insert({
        project_id: projectId,
        uploaded_by: userId,
        title: title || file?.name,
        image_note: imageNote || null,
        file_path: filePath,
        file_size: file?.size,
        mime_type: file?.type,
        is_upload: true,
      })
      ?.select('*, uploaded_by_profile:user_profiles!project_images_uploaded_by_fkey(id, full_name, first_name, last_name, email)')
      ?.single();
    if (error) throw error;
    return data;
  },

  async getSignedUrl(filePath) {
    const { data, error } = await supabase
      ?.storage
      ?.from(BUCKET)
      ?.createSignedUrl(filePath, 3600);
    if (error) throw error;
    return data?.signedUrl;
  },

  async delete(image) {
    if (image?.is_upload && image?.file_path) {
      await supabase?.storage?.from(BUCKET)?.remove([image?.file_path]);
    }
    const { error } = await supabase?.from('project_images')?.delete()?.eq('id', image?.id);
    if (error) throw error;
  },
};
